"use client";

import * as React from "react";
import { cn } from "../../lib/utils";
import RoundCheckIcon from "../icons/roundCheckIcon";
import { WebsiteIcon } from "../icons/WebsiteIcon";

export interface SocialConnectButtonProps {
  icon: React.ReactNode;
  label: string;
  status?: "connected" | "connect";
  onClick?: () => void;
}

export function SocialConnectButton({ icon, label, status = "connect", onClick }: SocialConnectButtonProps) {
  const isConnected = status === "connected";
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center justify-between rounded-lg border border-black bg-white px-3 py-2"
    >
      <div className="flex items-center gap-2">
        <span>{icon}</span>
        <span
          className={cn(
            "text-sm font-medium",
            label === "LinkedIn" && "text-[#0D41E1]",
            label === "Instagram" && "text-[#EF439F]",
            label === "Facebook" && "text-[#1877F2]",
            label === "Website" && "text-[#2EB67D]",
            !["LinkedIn", "Instagram", "Facebook", "Website"].includes(label) && "text-[#344054]"
          )}
        >
          {label}
        </span>
      </div>
      <div
        className={cn(
          "flex h-6 w-6 items-center justify-center rounded-full border",
          isConnected ? "bg-[rgba(46,182,125,0.12)] border-transparent" : "bg-[rgba(13,65,225,0.06)] border-transparent"
        )}
      >
        {isConnected ? (
          <span className="text-[#02C473]"><RoundCheckIcon/></span>
        ) : (
          <WebsiteIcon className="text-[#0D41E1]" />
        )}
      </div>
    </button>
  );
}
